<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-6" label="Vareid" v-model.trim="item.Vareid" :disabled="true"/>
              <TheTextInput containerClassName="cell large-6" label="Varekode" name="Varekode" :disabled="edit" v-model.trim="item.Varekode" maxlength="10" required v-validate="'required|max:10'"/>
              <TheTextInput containerClassName="cell large-6" label="Beskrivelse" name="Beskrivelse" v-model.trim="item.Beskrivelse" maxlength="100" v-validate="'max:100'"/>
              <TheDecimalInput containerClassName="cell large-3" label="Pris" name="Pris" v-model.trim="item.Pris" maxlength="10" v-validate="'max:10'"/>
              <TheSwitchInput containerClassName="cell large-3" v-model="item.Prisinclmva" label="Pris incl MVA" labelTrue="Ja" labelFalse="Nei" trueValue="T" falseValue="F"/>

              <TheSelectInput containerClassName="cell large-3" label="Enhetskode" name="Enhetskode" v-model.trim="item.Enhetskode" :items="vareenhetOptions"/>
              <TheSelectInput containerClassName="cell large-3" label="Mvakode" name="Mvakode" v-model.trim="item.Mvakode" :items="mvaOptions"/>
              <TheSelectInput containerClassName="cell large-3" label="Bokforgruppekode" name="Bokforgruppekode" v-model.trim="item.Bokforgruppekode" :items="bokforgruppeOptions"/>
              <TheSelectInput containerClassName="cell large-3" label="Type (Bilagsart)" name="Bilagsart" v-model.trim="item.Bilagsart" :items="bilagsartOptions"/>

              <TheTextInput containerClassName="cell large-6" label="24 Konto Mva" name="twentyfoursevenkontomva" v-model.trim="item.twentyfoursevenkontomva"/>
              <TheTextInput containerClassName="cell large-6" label="24 Konto Mvafri" name="twentyfoursevenkontomvafri" v-model.trim="item.twentyfoursevenkontomvafri"/>

              <TheTextInput containerClassName="cell large-4" label="24so oppgjør mva-konto" name="twentyfoursevenmvakontomva" v-model.trim="item.twentyfoursevenmvakontomva"/>
              <TheTextInput containerClassName="cell large-4" label="24so oppgjør mva-konto mvafr" name="twentyfoursevenmvakontomvafri" v-model.trim="item.twentyfoursevenmvakontomvafri"/>
              <TheTextInput containerClassName="cell large-4" label="24so oppgjør mva-konto eksport" name="twentyfoursevenmvakontoeksport" v-model.trim="item.twentyfoursevenmvakontoeksport"/>

              <TheSwitchInput containerClassName="cell large-12" v-model="item.Status" label="Status" labelTrue="Aktiv" labelFalse="Inaktiv"/>
            </div>
          </fieldset>

          <fieldset>
            <div class="cell large-12" v-if="canEdit247">
              <div class="input-container checkbox" :class="{'form-error': errors.has('haveTwentyfourseven')}">
                <input type="hidden" name="haveTwentyfourseven" v-model.trim="haveTwentyfourseven" value="1" v-validate="'max: 4'">
                <span class="form-error-label" style="text-align: left; position: initial;" v-if="errors.has('haveTwentyfourseven')">
                  Vennligst velg eller opprett kategori
                </span>
              </div>
            </div>
            <div class="grid-x grid-padding-x">
              <TheSelectInput containerClassName="cell large-6" label="Nettauksjon kategori, 247" name="tw47_net_id" v-model="tw47data.net.id" :items="netCategoryOptions" :disabled="!canEdit247"/>
              <TheTextInput containerClassName="cell large-6" label="Oprett ny" name="tw47_net_name" v-model.trim="tw47data.net.name" maxlength="100" v-validate="'max:100'" :disabled="!canEdit247"/>
            </div>
            <div class="grid-x grid-padding-x">
              <TheSelectInput containerClassName="cell large-6" label="Kunsthandel kategori, 247" name="tw47_art_id" v-model="tw47data.art.id" :items="artCategoryOptions" :disabled="!canEdit247"/>
              <TheTextInput containerClassName="cell large-6" label="Oprett ny" name="tw47_art_name" v-model.trim="tw47data.art.name" maxlength="100" v-validate="'max:100'" :disabled="!canEdit247"/>
            </div>
            <div class="grid-x grid-padding-x">
              <TheSelectInput containerClassName="cell large-6" label="Artsafe kategori, 247" name="tw47_artsafe_id" v-model="tw47data.artsafe.id" :items="artsafeCategoryOptions" :disabled="!canEdit247"/>
              <TheTextInput containerClassName="cell large-6" label="Oprett ny" name="tw47_artsafe_name" v-model.trim="tw47data.artsafe.name" maxlength="100" v-validate="'max:100'" :disabled="!canEdit247"/>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'
import axios from 'axios'

export default {
  name: 'InstillingerVareEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      item: {},
      mvaOptions: [],
      vareenhetOptions: [],
      bokforgruppeOptions: [],
      bilagsartOptions: [],
      categoryList: [],
      loading: true,
      tw47data: {
        net: {
          id: null,
          name: null
        },
        art: {
          id: null,
          name: null
        },
        artsafe: {
          id: null,
          name: null
        }
      }
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  computed: {
    haveTwentyfourseven: function () {
      if (!this.canEdit247) {
        return true
      }

      if ((this.tw47data.net.id || this.tw47data.net.name) && (this.tw47data.art.id || this.tw47data.art.name) && (this.tw47data.artsafe.id || this.tw47data.artsafe.name)) {
        return true
      }

      return false
    },
    canEdit247: function () {
      if (this.item.Varekode === 'OBJEKT' || this.item.Varekode === 'SALÆR' || this.item.Varekode === 'OPPGJØR' || this.item.Varekode === 'FOTO' || this.item.Varekode === 'BKH') {
        return false
      }

      if (this.netCategorySelected && this.artCategorySelected && this.artsafeCategorySelected) {
        return false
      }

      return true
    },
    netCategoryOptions: function () {
      let retval = this.categoryList && this.categoryList.web_auction ? this.categoryList.web_auction : []

      if (retval.length > 0) {
        retval.unshift({key: null, val: 'Velg kategori hos 247...'})
      } else {
        retval.unshift({key: null, val: 'Mangler kategori hos 247...'})
      }

      return retval
    },
    artCategoryOptions: function () {
      let retval = this.categoryList && this.categoryList.art_trade ? this.categoryList.art_trade : []

      if (retval.length > 0) {
        retval.unshift({key: null, val: 'Velg kategori hos 247...'})
      } else {
        retval.unshift({key: null, val: 'Mangler kategori hos 247...'})
      }

      return retval
    },
    artsafeCategoryOptions: function () {
      let retval = this.categoryList && this.categoryList.artsafe ? this.categoryList.artsafe : []

      if (retval.length > 0) {
        retval.unshift({key: null, val: 'Velg kategori hos 247...'})
      } else {
        retval.unshift({key: null, val: 'Mangler kategori hos 247...'})
      }

      return retval
    },
    netCategorySelected: function () {
      let array = this.item.twentyfourseven_products || []
      let found = array.find(i => i.Varekode === this.item.Varekode && i.Konto === 'web_auction')

      if (found) {
        return found.ExternKategoriId
      }

      return null
    },
    artCategorySelected: function () {
      let array = this.item.twentyfourseven_products || []
      let found = array.find(i => i.Varekode === this.item.Varekode && i.Konto === 'art_trade')

      if (found) {
        return found.ExternKategoriId
      }

      return null
    }
  },
  watch: {
    'tw47data.net.id': function (newVal) {
      if (newVal) {
        this.tw47data.net.name = null
      }
    },
    'tw47data.net.name': function (newVal) {
      if (newVal) {
        this.tw47data.net.id = null
      } else if (newVal !== undefined) {
        this.tw47data.net.id = this.netCategorySelected
      }
    },
    'tw47data.art.id': function (newVal) {
      if (newVal) {
        this.tw47data.art.name = null
      }
    },
    'tw47data.art.name': function (newVal) {
      if (newVal) {
        this.tw47data.art.id = null
      } else if (newVal !== undefined) {
        this.tw47data.art.id = this.artCategorySelected
      }
    },
    'tw47data.artsafe.id': function (newVal) {
      if (newVal) {
        this.tw47data.artsafe.name = null
      }
    },
    'tw47data.artsafe.name': function (newVal) {
      if (newVal) {
        this.tw47data.artsafe.id = null
      } else if (newVal !== undefined) {
        this.tw47data.artsafe.id = this.artsafeCategorySelected
      }
    }
  },
  methods: {
    fetch: function () {
      this.mvaOptions.unshift({key: this.item.Mvakode, val: 'Laster...'})
      this.vareenhetOptions.unshift({key: this.item.Enhetskode, val: 'Laster...'})
      this.bokforgruppeOptions.unshift({key: this.item.Bokforgruppekode, val: 'Laster...'})
      this.bilagsartOptions.unshift({key: this.item.Bilagsart, val: 'Laster...'})

      this.loadDropdowns()
        .then((response) => {
          this.vareenhetOptions = response.vareenhet
          this.vareenhetOptions.unshift({key: null, val: 'Velg vareenhet'})

          this.mvaOptions = response.mva
          this.mvaOptions.unshift({key: null, val: 'Velg mva'})

          this.bokforgruppeOptions = response.bokforgruppe
          this.bokforgruppeOptions.unshift({key: null, val: 'Velg bokforgruppe'})

          this.bilagsartOptions = []
          response.bilagsart.forEach(element => {
            this.bilagsartOptions.push({key: element.key, val: element.name})
          })
          this.bilagsartOptions.unshift({key: null, val: 'Alle'})

          this.categoryList = response.categories

          if (!this.edit) {
            this.item.Prisinclmva = 'F'

            this.setFormLoading(false)
          } else {
            this.service.view(this.$route.params.id)
              .then((response) => {
                this.item = response.data

                this.tw47data.net.id = this.netCategorySelected
                this.tw47data.art.id = this.artCategorySelected
              })
              .catch(() => {
                this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn vare')

                this.onCancel()
              })
              .then(() => {
                this.setFormLoading(false)
              })
          }
        })
    },
    loadDropdowns: function () {
      return new Promise((resolve, reject) => {
        axios
          .all([
            InstillingerService('vareenhet').dropdown(),
            InstillingerService('mva').dropdown(),
            InstillingerService('bokforgruppe').dropdown(),
            InstillingerService('bilagart').dropdown(),
            InstillingerService('kategori').twentyfourseven()
          ])
          .then(
            axios.spread(function (vareenhet, mva, bokforgruppe, bilagsart, categories) {
              resolve({
                vareenhet: vareenhet.data,
                mva: mva.data,
                bokforgruppe: bokforgruppe.data,
                bilagsart: bilagsart.data,
                categories: categories.data
              })
            })
          )
          .catch(error => {
            reject(error)
          })
      })
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      let data = this._.cloneDeep(this.item)

      if (this.canEdit247) {
        data.twentyfourseven = this.tw47data
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // Force code to be uppercase
            data.Varekode = this._.toUpper(this.item.Varekode)

            this.service.save(this.item.Vareid, data)
              .then((response) => {
                this.$helpers.showSuccessAlert('Vare er lagret')

                this.item = response.data

                this.tw47data.net.id = this.netCategorySelected
                this.tw47data.art.id = this.artCategorySelected
                this.tw47data.artsafe.id = this.artsafeCategorySelected

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
input[name="Varekode"] {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerVareEdit.vue